<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-modal-device">
      <h2>Desconectar dispositivo</h2>
    </div>

    <div class="body-modal-device">
      <p>Você tem certeza que deseja se desconectar do dispositivo abaixo:</p>
      <div class="info-device">
        <div class="icon-device">
          @if (!this.automaticLoginStruct .automaticLogin.isMobile) {
            <mat-icon aria-hidden="false" aria-label="devices">laptop</mat-icon>
          }
          @if (this.automaticLoginStruct .automaticLogin.isMobile) {
            <mat-icon aria-hidden="false" aria-label="devices">smartphone</mat-icon>
          }
        </div>
        <h2 class="primary">{{this.automaticLoginStruct .automaticLogin.browser}} ({{this.automaticLoginStruct .automaticLogin.device}})</h2>
      </div>
      <span class="secundary-status last-info">Última sessão ativa: {{this.automaticLoginStruct .lastSession}}</span>
    </div>

    <div class="footer-modal-device">
      <button mat-flat-button color="accent" class="btn-block"(click)="close()">
        @if (isLoading == false) {
          <span>Voltar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
      <button mat-flat-button color="warn" class="btn-block" (click)="deleteAutomaticLogin()">
        @if (isLoading == false) {
          <span>Desconectar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>